package one.healthium.intercom

import one.healthium.domain.user.UserModel
import one.primehealth.app.BaseAppConfig
import kotlin.time.Clock

actual object IntercomPlatform {
    private lateinit var baseAppConfig: BaseAppConfig

    fun init(baseAppConfig: BaseAppConfig) {
        this.baseAppConfig = baseAppConfig
    }

    actual suspend fun present(user: UserModel) {
        val intercomProps = js("({})").unsafeCast<InitProps>().apply {
            appId = baseAppConfig.intercomAppKey
            userId = user.id
            name = user.profile.name
            email = user.profile.email
            createdAt = Clock.System.now().epochSeconds
        }

        IntercomSdk.init(intercomProps)
//        IntercomSdk.update(buildAttributesMap(user, baseAppConfig))
        IntercomSdk.show()
    }
}